import { useState, type FormEvent } from "react";
import { useAsyncAction } from "@/hooks/useAsyncAction";
import { api, type AvanceAdmin } from "@/lib/api";
import { validarInicio } from "@/lib/avance";

/** Lógica del formulario de la fecha de inicio de obra (sin JSX). Vacía = "todavía no se sabe". */
export function useFormularioInicio(fid: number, inicial: string | null, alGuardar: () => void) {
  const [valor, setValor] = useState(inicial ?? "");
  const [mostrarError, setMostrarError] = useState(false);
  const error = validarInicio(valor);
  const accion = useAsyncAction(() => api.put<AvanceAdmin>(`/api/fideicomisos/${fid}/avance/inicio`, { inicio: valor || null }).then(() => true));
  return {
    valor,
    cambiar: setValor,
    error: mostrarError ? error : null,
    guardar: async (e: FormEvent) => {
      e.preventDefault();
      setMostrarError(true);
      if (error) return;
      if (await accion.run()) alGuardar();
    },
    guardando: accion.loading,
    errorGuardar: accion.error,
  };
}
